import { gql } from "@apollo/client";

const UploadsQuery = gql`
  query AllUploads {
    allUploads(orderBy: UPLOADED_DESC) {
      nodes {
        projectName
        projectByProjectName {
          isActive
        }
        imageCount
        id
        status
        uploaded
        zipFileName
        zipFileSize
        imageCount
        isBulk
        inQaqc
        userByUserId {
          appId
          email
          firstName
          lastName
        }
        failedFilesByUploadId {
          totalCount
        }
      }
    }
  }
`;

const hash = "1861daf3087a076476f05cc1d6969c77627f0a9c3ed6f7b5e6116c3b5f5e7b1d";

export { UploadsQuery, hash };
